import { render, staticRenderFns } from "./PerformancesImportFile.vue?vue&type=template&id=0ca87539&"
import script from "./PerformancesImportFile.vue?vue&type=script&lang=js&"
export * from "./PerformancesImportFile.vue?vue&type=script&lang=js&"
import style0 from "./PerformancesImportFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports